import type { CheckDepthTier } from '@nestjs-boilerplate/types';
import { atom } from 'jotai';

/**
 * State for the risk assessment wizard, persisted across route navigation.
 */
export interface WizardState {
  /** Selected screening checks from the list selection step */
  selectedChecks: string[];
  /** Selected tier from the depth selection step */
  selectedTier: CheckDepthTier | null;
}

const initialWizardState: WizardState = {
  selectedChecks: [],
  selectedTier: null,
};

/**
 * Atom holding the wizard state.
 */
export const wizardStateAtom = atom<WizardState>(initialWizardState);

/**
 * Atom to update selected checks.
 */
export const setSelectedChecksAtom = atom(null, (get, set, checks: string[]) => {
  const current = get(wizardStateAtom);
  set(wizardStateAtom, { ...current, selectedChecks: checks });
});

/**
 * Atom to update selected tier.
 */
export const setSelectedTierAtom = atom(null, (get, set, tier: CheckDepthTier | null) => {
  const current = get(wizardStateAtom);
  set(wizardStateAtom, { ...current, selectedTier: tier });
});

/**
 * Atom to reset wizard state (when starting a new assessment or completing one).
 */
export const resetWizardStateAtom = atom(null, (_get, set) => {
  set(wizardStateAtom, initialWizardState);
});
